import {
  mapLocaleAliasToSupportedLocale,
  SupportedLocale,
} from '@/utils/i18n/supportedLocales';

/**
 * The affiliate referral programme is paused for the Japanese market while its
 * local incentive mechanics are reviewed (LOC-320).
 */
export const isReferralProgramAvailableForLocale = (locale?: string | null): boolean => {
  if (!locale) return true;

  return mapLocaleAliasToSupportedLocale(locale) !== SupportedLocale.JaJp;
};
